import { useAuth } from "@/components/contexts/AuthContext";
import { UserPermissionsEnum } from "@t/UserPermissionsEnum";
import { useCallback } from "react";

function usePermissions() {
    const {
        authState: { user },
    } = useAuth();

    const hasPermission = useCallback(
        (perm: UserPermissionsEnum): boolean => {
            const permissions = user.permissions ?? [];
            return permissions.includes(perm);
        },
        [user.permissions, user.userRole]
    );

    return { hasPermission };
}

export default usePermissions;
